import request from "./request"
import Axios from "axios";

const getUserOpenId = async (code) => {
    const resp = await request.get(`api/v1/payment/getUserOpenId/${code}`);
    return resp.data;
  };
  
  export default getUserOpenId;
  